import { gql } from '@apollo/client';

export const queryName = 'memberInterests';
export const memberInterestsName = 'MemberInterests';
export const memberInterests = gql`
	fragment ${memberInterestsName} on Member {
		interests {
			nodes {
				memberFolxInterestID
				name
				value
			}
		}
	}
`;
